// extracted by mini-css-extract-plugin
export var container = "_7o-0";
export var icon = "_7o-1";
export var text = "_7o-2";